module.exports = __webpack_public_path__ + "img/other-icon-img6.08198f49.svg";